// Vue
import Vue from 'vue';
import App from './App';

// 配置
import Setting from './setting';

// 混合
import mixinApp from '@/mixins/app';

// 插件
import plugins from '@/plugins';

// store
import store from '@/store/index';

// iView 和 iView Pro
import ViewUI from 'view-design';
import iViewPro from '@/libs/iview-pro/iview-pro.min.js';

// 菜单和路由
import router from './router';
import menuHeader from '@/menu/header';
import menuSider from '@/menu/sider';
import menuSiderBcos from '@/menu/sider-bcos';
import { frameInRoutes } from '@/router/routes';

// 多语言
import i18n from '@/i18n';

// 方法
import { getHeaderName, getMenuSider, getSiderSubmenu } from '@/libs/system';

// 内置组件
import iLink from '@/components/link';
import iFrame from '@/components/frame';

// 使用样式，修改主题可以在 styles 目录下创建新的主题包并修改 iView 默认的 less 变量
import './styles/index.less';
import './libs/iview-pro/iview-pro.css';

// 添加事件管理者'passive'，来阻止'touchstart'事件，让页面更加流畅
import "default-passive-events"

// 初始化一个全局事件总线
Vue.prototype.$Bus = new Vue()


// 动画效果
import 'animate.css'

if (window) window.$t = (key, value) => i18n.t(key, value);

Vue.use(plugins);

Vue.use(ViewUI, {
    i18n: (key, value) => i18n.t(key, value)
});
Vue.use(iViewPro);
Vue.component('i-link', iLink);
Vue.component('i-frame', iFrame);

// vxetable表格组件
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable);
Vue.prototype.$VXETable = VXETable;

// 日期时间处理
import moment from 'moment';
Vue.prototype.$moment = moment;

// elementUI
// import i18nBcos from '@/bcos/lang' // internationalization

/*iconfont*/
// import '@/bcos/assets/icon/iconfont.css'
// import '@/bcos/assets/icon/iconfont.js'
// import '@/bcos/assets/icon/iconfont_webaas.css'
// import '@/bcos/svgIcons'
/*public css moudle */
// import '@/bcos/assets/css/common.css'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import Cookies from 'js-cookie'
// Vue.use(ElementUI, {
//     size: Cookies.get('size') || 'medium', // set element-ui default size
//     i18nBcos: (key, value) => i18nBcos.t(key, value)
// });
// ElementUI.Dialog.props.closeOnClickModal.default = false

// elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

// 接口
import { queryGroup } from "@/api/bcos/bcos"


new Vue({
    mixins: [mixinApp],
    router,
    store,
    i18n,
    render: h => h(App),
    data() {
        return {
            group: null,
            groupName: "",
            groupList: [],
            loading: false,
            show: false,
        }
    },
    created() {
        // 处理路由 得到每一级的路由设置
        this.$store.commit('admin/page/init', frameInRoutes);
        // 设置顶栏菜单
        this.$store.commit('admin/menu/setHeader', menuHeader);
        // 加载用户登录的数据
        this.$store.dispatch('admin/account/load');
        // 初始化全屏监听
        this.$store.dispatch('admin/layout/listenFullscreen')
    },
    watch: {
        // 监听路由 控制侧边栏显示 标记当前顶栏菜单（如需要）
        '$route'(to, from) {
            let path = to.matched[to.matched.length - 1].path;

            let sider = menuSider
            if (path.startsWith("/bcos/")) {
                sider = menuSiderBcos

                // 非区块链浏览器模块
                if (!path.startsWith("/bcos/browser")) {
                    this.getGroup()
                }
            } else {
                sider = menuSider
            }

            if (!Setting.dynamicSiderMenu) {
                let headerName = getHeaderName(path, sider);
                if (headerName === null) {
                    path = to.path;
                    headerName = getHeaderName(path, sider);
                }
                // 在 404 时，是没有 headerName 的
                if (headerName !== null) {
                    this.$store.commit('admin/menu/setHeaderName', headerName);
                    this.$store.commit('admin/menu/setMenuSider', sider);

                    const filterMenuSider = getMenuSider(sider, headerName);
                    this.$store.commit('admin/menu/setSider', filterMenuSider);
                    this.$store.commit('admin/menu/setActivePath', to.path);

                    const openNames = getSiderSubmenu(path, sider);
                    this.$store.commit('admin/menu/setOpenNames', openNames);
                }
            }
            this.appRouteChange(to, from);
        }
    },
    methods: {
        getGroup() {
            this.loading = true;
            queryGroup()
                .then((res) => {
                    this.loading = false;
                    const { data, status, statusText } = res;
                    if (status === 200 && data && data.length) {
                        let arr = data.sort((a, b) => {
                            return a - b;
                        }),
                            list = [];
                        for (let i = 0; i < arr.length; i++) {
                            list.push({
                                group: arr[i],
                                groupName: `group${arr[i]}`,
                            });
                        }
                        this.groupList = list;
                        if (!this.group) {
                            this.group = this.groupList[0].group;
                            this.groupName = this.groupList[0].groupName;
                        } else {
                        }
                        localStorage.setItem("groupName", this.groupName);
                        localStorage.setItem("groupId", this.group);
                        this.show = true;
                        localStorage.setItem("cluster", JSON.stringify(list));
                    } else {
                        this.show = true;
                        localStorage.setItem("groupName", "");
                        localStorage.setItem("groupId", "");
                        if (res.data.code) {
                            this.$message({
                                type: "error",
                                message: this.$chooseLang(res.data.code),
                            });
                        }
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.show = true;
                    localStorage.setItem("groupName", "");
                    localStorage.setItem("groupId", "");
                    this.$message({
                        type: "error",
                        message: err.data || this.$t("text.systemError"),
                    });
                });
        },
    }
}).$mount('#app');
